module.exports = __webpack_public_path__ + "img/videoagentproc.5875f36c.svg";